import React, { useState } from 'react'
import { TextField, Paper, Tabs, Tab, AppBar } from "@material-ui/core";

export default function Settings(props) {
  const [selectedTab, setSelectedTab] = useState(0);

  let getType = () => {
    let typePersonel = '';
    switch (selectedTab) {
      case 0:
        typePersonel = '_per'
        break;
      case 1:
        typePersonel = '_uit'
        break;
      case 2:
        typePersonel = '_zzp'
        break;
      default:
        break;
    }
    return typePersonel;
  }

  let update = (ev) => {
    let settings = props.settings;
    settings[ev.target.id + getType()] = ev.target.value;
    props.handleUpdate(settings);
  }


  let updateMateriaal = (ev) => {
    let settings = props.settings;
    settings.articlemateriaal = ev.target.value;
    props.handleUpdate(settings);
  }

  let getValue = (attribute) => {
    return props.settings[attribute + getType()]
  }

  return (
    <React.Fragment>
      <AppBar position="static" color="primary">
        <Tabs value={selectedTab} onChange={(ev, val) => { setSelectedTab(val) }}>
          <Tab label="Personeel"></Tab>
          <Tab label="Uitzendkracht"></Tab>
          <Tab label="ZZP-er"></Tab>
          <Tab label="Algemeen"></Tab>
        </Tabs>
      </AppBar>
      <div className="padding">

        {selectedTab === 3 &&
          <Paper className="padding">
            <TextField
              margin="dense"
              id="articlemateriaal"
              label="Artikelnummer materiaal"
              type="text"
              value={props.settings.articlemateriaal || 0}
              onChange={updateMateriaal}
              fullWidth
              required
            />
          </Paper>
        }
        {selectedTab !== 3 && <React.Fragment>
          <Paper className="padding">
            <TextField
              margin="dense"
              id="uurloonwerkplaats"
              label="Uurloon werkplaats (Euro)"
              type="number"
              value={getValue('uurloonwerkplaats') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="articleuurloonwerkplaats"
              label="Artikelnr. Visma uurloon werkplaats"
              type="text"
              value={getValue('articleuurloonwerkplaats') || ''}
              onChange={update}
              fullWidth
            />
          </Paper>
          <br /><br />
          <Paper className="padding">
            <TextField
              margin="dense"
              id="uurloonlocatie"
              label="Uurloon montage/locatie (Euro)"
              type="number"
              value={getValue('uurloonlocatie') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="articleuurloonlocatie"
              label="Artikelnr. Visma uurloon montage/locatie (Euro)"
              type="text"
              value={getValue('articleuurloonlocatie') || ''}
              onChange={update}
              fullWidth
            />
          </Paper>
          <br /><br />
          <Paper className="padding">
            <TextField
              margin="dense"
              id="overuren"
              label="Uurloon overuren (percentage)"
              type="number"
              value={getValue('overuren') || 0}
              onChange={update}
              fullWidth
              required
            />

            <TextField
              margin="dense"
              id="zaterdag"
              label="Uurloon zaterdag (percentage)"
              type="number"
              value={getValue('zaterdag') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="zondag"
              label="Uurloon zondag (percentage)"
              type="number"
              value={getValue('zondag') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="articleoveruren"
              label="Artikelnr. Visma uurloon overuren/zaterdag/zondag"
              type="text"
              value={getValue('articleoveruren') || ''}
              onChange={update}
              fullWidth
            />
          </Paper>
          <br /><br />
          <Paper className="padding">
            <TextField
              margin="dense"
              id="gasgeven"
              label="Uurloon gasgeven (Euro)"
              type="number"
              value={getValue('gasgeven') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="articlegasgeven"
              label="Artikelnr. Visma uurloon gasgeven"
              type="text"
              value={getValue('articlegasgeven') || ''}
              onChange={update}
              fullWidth
            />
          </Paper>
          <br /><br />
          <Paper className="padding">
            <TextField
              margin="dense"
              id="overnachting"
              label="Vergoeding overnachting (Euro)"
              type="number"
              value={getValue('overnachting') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="articleovernachting"
              label="Artikelnr. Visma vergoeding overnachting"
              type="text"
              value={getValue('articleovernachting') || ''}
              onChange={update}
              fullWidth
            />
          </Paper>
          <br /><br />
          <Paper className="padding">
            <TextField
              margin="dense"
              id="reisuren"
              label="Vergoeding reisuren (Euro)"
              type="number"
              value={getValue('reisuren') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="articlereisuren"
              label="Artikelnr. Visma vergoeding reisuren"
              type="text"
              value={getValue('articlereisuren') || ''}
              onChange={update}
              fullWidth
            />
          </Paper>
          <br /><br />
          <Paper className="padding">
            <TextField
              margin="dense"
              id="kmvergoeding"
              label="Kilometervergoeding (Euro)"
              type="number"
              value={getValue('kmvergoeding') || 0}
              onChange={update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="articlekmvergoeding"
              label="Artikelnr. Visma kilometervergoeding"
              type="text"
              value={getValue('articlekmvergoeding') || ''}
              onChange={update}
              fullWidth
            />
          </Paper>

        </React.Fragment>}
        <br /><br />
      </div>
    </React.Fragment>
  )
}
